import React from 'react';
import QAHistory from './QAHistory';
import {
  getKnowledgeQAHistory,
  getKnowledgeQAStatistics,
  submitKnowledgeFeedback,
  markKnowledgeQAAnswer,
} from '../services/knowledgeService';

function KnowledgeQAHistory() {
  return (
    <QAHistory
      agentName="Knowledge Agent"
      fetchHistory={getKnowledgeQAHistory}
      fetchStatistics={getKnowledgeQAStatistics}
      submitFeedback={(qaId, feedback) => submitKnowledgeFeedback(qaId, feedback)}
      markAnswer={(qaId, isCorrect) => markKnowledgeQAAnswer(qaId, isCorrect)}
    />
  );
}

export default KnowledgeQAHistory;
